module.exports = __webpack_public_path__ + "static/img/BJ.d0516ea5.svg";